import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import axios from 'axios';
import * as $ from 'jquery';
import Moment from 'moment'
import 'bootstrap'
import Select from 'react-select';

const Booking = (props) => {
    const [Post, setPost] = useState({ option1: "", option2: "", BookingId: "", company_id: props.companyid });
    const [items, setitems] = useState([]);
    const [bookingdetails, setbookingdetails] = useState({});
    const [receviedamount, setreceviedamount] = useState({});
    const [typevalue, settypevalue] = useState()
    const [type, settype] = useState([
        { label: "Null Amount", value: "1" },
        { label: "Some Amount", value: "2" },
    ])
    const [typenewvalue, settypenewvalue] = useState()
    const [typenew, settypenew] = useState([
        { label: "Less Amount", value: "1" },
        { label: "Full Amount", value: "2" },


    ])
    const settypevalues = (e) => {
        debugger;
        setPost({ ...Post, option1: e.value })

    }
    const settypenewvalues = (e) => {
        debugger;
        setPost({ ...Post, option2: e.value })

    }
    const url = process.env.REACT_APP_APIURL + "Booking/GetALLBookingsver?companyid=" + props.companyid;

    useEffect(() => {
        setTimeout(() => {
            $('#example3').DataTable().destroy()
            populatedata()
        }, 100)

    }, []);
    useEffect(() => {
        $('#example3').DataTable();
    }, [items]);

    async function populatedata() {
        await fetch(url).then(res => res.json()).then(result => {
            setitems(result);
        }
        );
    }
    async function deletedata(id) {
        const urldelete = process.env.REACT_APP_APIURL + 'Booking/DeleteBooking?bookingId=' + id;
        let res = await axios.post(urldelete)
        if (res.status == 200) {
            swal({
                title: "Deleted Successfully",
                icon: "success"
            })
            populatedata();

        }
    }
    async function handleview(id) {
        const url = process.env.REACT_APP_APIURL + "Booking/GetALLBooking?bookingId=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {
            if (result.status == 404) {
                swal(
                    {
                        icon: 'error',
                        title: 'Not found!',
                    })
            }
            else {
                $("#myModal").modal('show');
                setbookingdetails(result)
                paymentdata(id)
                //console.log(result)
            }

        }).catch((err) => {
            console.log(err);
        });
    }
    async function handleactive(id) {
    }
    async function paymentdata(id) {
        const url = process.env.REACT_APP_APIURL + "payment/GetReceviedAmount?bookingid=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {

            if (result.status == 404) {
                receviedamount.payment = 0
            }
            else {
                setreceviedamount(result);
            }

        }).catch((err) => {
            console.log(err);
        });
    }
    function handleDelete(id) {
        debugger;
        setPost({ ...Post, BookingId: id })

        $("#myModal1").modal('show');
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        debugger;
        const formData = new FormData();

        /*await formData.append("Company_id", Post.company_id);*/
        await formData.append("bookingid", Post.BookingId);
        await formData.append("option1", Post.type);
        await formData.append("option2", Post.typenew);
        try {
            const res = await axios.post(process.env.REACT_APP_APIURL + "Booking/AddVerify", formData,
                {
                    headers: {
                        'content-type': 'form-data'
                    }
                })
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    //  text: "Once deleted, you will not be able to recover this imaginary file!",
                    icon: "success"
                })
                $("#myModal1").modal('hide');

            }
        }
        catch (ex) {
            console.log(ex)
            return 0;
        }
    }
    return (
        <div className="row">
            <div className="col-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-0">Post Booking</h3>
                    </div>
                    <div className="card-body">

                        <div className="table-responsive">
                            <table id="example3" className="display" data-page-length='50'>
                                <thead>
                                    <tr>
                                        <th>Booking ID</th>
                                        <th>Customer</th>
                                        <th>Date</th>
                                        <th>Unit</th>
                                        <th>Shift</th>
                                        <th>Verified/Unverified</th>
                                        <th>Detail</th>
                                       {/* <th>Verification</th>*/}

                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map(item =>

                                        <tr key={item.bookingId}>
                                            <td>{item.bookingId}</td>
                                            <td>{item.cusName}</td>
                                            <td>{Moment(item.bookingdate).format('MM/DD/yyyy')}</td>
                                            <td>{item.unitName}</td>
                                            <td>{item.shiftName}</td>
                                            <td>{item.value}</td>
                                            {/*<td>{item.agent_Name}</td>*/}

                                            <td>
                                                <span className="d-flex">
                                                    <button href="#" className="btn btn-dark shadow btn-xs sharp me-2"
                                                        onClick={() => handleview(item.bookingId)}>
                                                        <i className="fas fa-pencil-alt"></i>
                                                    </button>

                                                </span>

                                            </td>
                                            {/*<td>*/}
                                            {/*    <div className="checkbox-group" id="checkboxes">*/}
                                            {/*        <ul>*/}
                                            {/*            <li>*/}

                                            {/*                <button href="#" className="btn btn-light shadow sharp me-2"*/}
                                            {/*                    onClick={() => handleDelete(item.bookingId)}>*/}
                                            {/*                    Verify*/}
                                            {/*                </button>*/}
                                            {/*            </li>*/}
                                            {/*        </ul>*/}
                                            {/*    </div>*/}
                                            {/*</td>*/}

                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModal" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="me-auto mb-0">Booking Details</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-12 col-lg-6">
                                        <p className="total_amount">Customer Name: <span >{bookingdetails.cusName}</span></p>
                                        <p className="total_amount">No of Members: <span>{bookingdetails.noOfMembers}</span></p>
                                        <p className="total_amount">Email: <span>{bookingdetails.email}</span></p>
                                        <p className="total_amount">Phone: <span>{bookingdetails.phone}</span></p>
                                        <p className="total_amount">CNIC: <span>{bookingdetails.cnic}</span></p>
                                        <p className="total_amount">Address: <span>{bookingdetails.address}</span></p>
                                        <p className="total_amount">Booking Date: <span>{Moment(bookingdetails.bookingdate).format('MM/DD/yyyy')}</span></p>
                                        <p className="total_amount">Entry Date: <span>{Moment(bookingdetails.entrydate).format('MM/DD/yyyy')} </span></p>
                                        <p className="total_amount">Unit : <span>{bookingdetails.unitName}</span></p>
                                        <p className="total_amount">Shift : <span>{bookingdetails.shiftName}</span></p>
                                        <p className="total_amount">Notes : <span>{bookingdetails.note}</span></p>
                                    </div>
                                    <div className="col-sm-12 col-lg-6">
                                        <p className="total_amount">Before Discount: <span>{bookingdetails.beforediscount}</span></p>
                                        <p className="total_amount">Discount: <span>{bookingdetails.discount}</span></p>
                                        <p className="total_amount">Amount: <span>{bookingdetails.amount}</span></p>
                                        <p className="total_amount">Received: <span>{receviedamount.payment}</span></p>
                                        <p className="total_amount">Remaining: <span>{(isNaN(bookingdetails.amount) ? 0 : bookingdetails.amount) - (isNaN(receviedamount.payment) ? 0 : receviedamount.payment)}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="myModal1" className="modal fade " tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="me-auto mb-5 mt-5 text-center mx-auto">Booking Verification</h3>
                            </div>
                            <div className="card-body">
                                <div className="basic-form">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row flex-column align-items-center">
                                            <div className="mb-5 col-6">
                                                <label htmlFor="booking_id" className="form-label">Option</label>
                                                <Select value={typevalue} options={type} onChange={(e) => { settypevalues(e); setPost({ ...Post, type: e.value }) }} />
                                            </div>
                                            <div className="mb-5 col-6">
                                                <label htmlFor="booking_id" className="form-label">Option</label>
                                                <Select value={typenewvalue} options={typenew} onChange={(e) => { settypenewvalues(e); setPost({ ...Post, typenew: e.value }) }} />
                                            </div>


                                            <br />

                                        </div>
                                        <div className="row justify-content-center inner-btn">
                                            <div>
                                                <button type="submit" className="btn btn-primary" id="book">Verify</button>
                                            </div>


                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Booking;